/**
 * Best-guess Apple Silicon detection via WebGL extension fingerprint.
 *
 * Apple has never guaranteed `WEBGL_compressed_texture_etc` to be present
 * specifically on Apple Silicon — this is a historical heuristic from
 * <https://stackoverflow.com/a/65412357>. It works today but can flip
 * across Safari releases without warning.
 *
 * Replace this with `navigator.userAgentData.getHighEntropyValues(['architecture'])`
 * once UA-CH support is added to the library (still pending — see ADR 0007).
 *
 * @returns {boolean} true if the WebGL fingerprint matches the Apple Silicon pattern
 */
export function isAppleSilicon() {
    try {
        if (typeof document === 'undefined') return false;
        const canvas = document.createElement('canvas');
        const gl = canvas.getContext('webgl');
        if (!gl) return false;
        return gl.getSupportedExtensions().indexOf('WEBGL_compressed_texture_etc') !== -1;
    } catch (e) {
        return false;
    }
}
